export default {
    kinds: {
        sleep: 'Sleep',
        nap: 'Nap',
        workout: 'Workout',
        meal: 'Meal',
        task: 'Task',
        project: 'Project',
        note: 'Note',
        report: 'Day entry',
        activity: 'Activity',
        event: 'Event',
        repeat: 'Recurring task',
        payment: 'Payment',
        personDate: 'Important date',
        care: 'Care',
    },
    filters: {
        events: 'Events',
        meals: 'Meals',
        sleep: 'Sleep',
        tasks: 'Tasks',
        workouts: 'Workouts',
        reports: 'Day entries',
        activities: 'Activities',
        payments: 'Payments',
    },
    weekdays: {
        short: { mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat', sun: 'Sun' },
        long: { mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday', fri: 'Friday', sat: 'Saturday', sun: 'Sunday' },
    },
    repeat: {
        none: 'No',
        daily: 'Every day',
        weekdays: 'On weekdays',
        weekly: 'Every week',
        monthly: 'Every month',
    },
    repeatRule: {
        daily: 'every day',
        weekdays: 'on weekdays',
        weekly: 'every week',
        monthly: 'every month',
        repeats: 'repeats',
        every: {
            daily: 'every {n} days',
            weekly: 'every {n} week | every {n} weeks',
            monthly: 'every {n} month | every {n} months',
        },
    },
    reminder: {
        none: 'None',
        onTime: 'On time',
        minutes: '{n} min before',
        hour: 'An hour before',
        day: 'A day before',
    },
    relation: {
        today: 'today',
        yesterday: 'yesterday',
        tomorrow: 'tomorrow',
    },
    flash: {
        settingsFailed: 'Couldn’t save the settings.',
        taskFailed: 'Couldn’t save the task change.',
        mealFailed: 'Couldn’t change the meal’s status.',
        workoutFailed: 'Couldn’t change the workout’s status.',
        rescheduleFailed: 'Couldn’t reschedule the tasks.',
        moveFailed: 'Couldn’t move the entry.',
        resizeFailed: 'Couldn’t change the length.',
        copied: 'Copied.',
        copyFailed: 'Couldn’t copy the entry.',
        removeFailed: 'Couldn’t delete the entry.',
        paymentFailed: 'Couldn’t save the payment in Wallet.',
        addTaskFailed: 'Couldn’t add the task.',
        refreshFailed: 'Couldn’t refresh the planner.',
    },
    overdue: {
        days: '{n} day | {n} days',
        one: 'one overdue',
        both: 'both overdue',
        all: 'all overdue',
        count: '{n} overdue',
    },
    quality: {
        poor: 'poor',
        average: 'average',
        good: 'good',
        great: 'great',
    },
    sleepQuality: {
        none: 'Not rated',
        poor: 'Poor',
        average: 'Average',
        good: 'Good',
        great: 'Great',
    },
    event: {
        allDay: 'all day',
        dayOf: 'day {n} of {total}',
        projectDue: 'Due: {title}',
    },
    workout: {
        pace: 'pace {pace} /km',
    },
    sleep: {
        qualityWord: 'quality {quality} · {word}',
        quality: 'quality {quality}',
        naps: '{n} nap | {n} naps',
        noBedtime: 'no bedtime',
        noWakeUp: 'no wake-up',
        goingToBed: 'Going to bed',
    },
    report: {
        detail: 'day report · {time}',
    },
    summary: {
        sleep: 'Sleep',
        sleepAvg: '{duration} on average over 7 days',
        calories: 'Calories',
        noGoal: 'no goal in your profile',
        move: 'Activity',
        activeKcal: '{kcal} active kcal',
        tasks: 'Tasks',
        protein: 'Protein',
        carbs: 'Carbs',
        fat: 'Fat',
        sugar: 'Sugars',
        fibre: 'Fibre',
    },
    maps: {
        pin: 'Google Maps pin',
    },
    firstSteps: {
        task: {
            title: 'A task for today', action: 'Add a task',
            what: 'Something to do today — type it in the box at the top and press Enter.',
            why: 'The day’s tasks show next to the schedule and in the summary; the ones you don’t tick off will come back as overdue.',
        },
        time: {
            title: 'A task with a time', action: 'Add with a time',
            what: 'E.g. “14:30 dentist” — the time at the start or at the end.',
            why: 'The task takes its place on the schedule, between meals and meetings.',
        },
        reminder: {
            title: 'Reminder', action: 'Set a reminder',
            what: 'A notification for a task with a time — on time or a little before.',
            why: 'No need to watch the clock — your phone will let you know. Set the default reminder in Settings.',
        },
        recurring: {
            title: 'Recurring task', action: 'Add a recurring task',
            what: 'Something that comes back: every day, on weekdays, on chosen days of the week or every month.',
            why: 'You enter it once — when you tick it off, it moves to the next day by itself, at the same time.',
        },
        meal: {
            title: 'Plan a meal', action: 'Plan',
            what: 'A meal for later or for tomorrow — from your catalogue or from products.',
            why: 'The schedule shows what you’ll eat and when; one button sends the ingredients of planned meals to Groceries.',
        },
        workout: {
            title: 'Plan a workout', action: 'Plan',
            what: 'A workout at a specific time.',
            why: 'It sits on the schedule like a meeting; after the workout you tick it off with the circle.',
        },
        sleep: {
            title: 'Log your sleep', action: 'Log sleep',
            what: 'When you fell asleep and woke up — or “Going to bed” and the wake-up in Fitness.',
            why: 'The night is drawn on the schedule, and the summary and weekly rhythm show how much and how regularly you sleep.',
        },
        report: {
            title: 'Day entry', action: 'Write',
            what: 'A few sentences in the evening: how the day went.',
            why: 'Together with the day’s numbers you can build an export for AI — with context the numbers don’t have.',
        },
        calendar: {
            title: 'Google Calendar', action: 'Connect',
            what: 'Connect your Google Calendar.',
            why: 'Meetings from your calendar will appear on the schedule next to the rest of your day.',
        },
    },
    help: {
        planer: {
            title: 'Planner',
            text: 'Your day in one place: meals, sleep, workouts, tasks, notes, calendar events and payments from Wallet — what has already happened and what’s planned. The planner has no entries of its own: everything comes from the modules, so a change here is a change there.',
            more: 'At the top you switch between Day, Week and Month. The arrows (or ← and → on the keyboard, a swipe on your phone) change the day, and “Today” takes you back to today.',
        },
        add: {
            title: 'Adding',
            text: 'Type a task and press Enter — it goes on this day. A time at the start or end (“14:30 dentist”) puts it straight on the schedule. ✨ “Type a sentence” in the box also recognises an event, meal, sleep and workout — e.g. “tomorrow at 6pm cinema with Anna”.',
            more: '“New entry” in the header (or the N key) opens a window with every kind of entry: a task with repeat and reminder, event, meal, sleep, note, workout, day entry. You can also click an hour on the schedule.',
        },
        timeline: {
            title: 'Schedule',
            text: 'The hours of the day with entries in their place: the length of a block is its duration (sleep, workout, event). The circle ticks off a task, an eaten meal or a finished workout. The red line is now.',
            more: 'Drag an entry to change its time — tasks, meals, workouts, notes and events (on your phone, press and hold for a moment). Click an empty spot on the schedule to add something at that time. Set the range of hours in Settings — the schedule stretches anyway if something is earlier or later.',
        },
        allDay: {
            title: 'All day',
            text: 'All-day events, project deadlines and Wallet payments for this day. Tick off a payment with the circle — it will be saved in Wallet as paid.',
        },
        overdue: {
            title: 'Overdue tasks',
            text: 'Unticked tasks whose time or day has already passed — from any day, not just today. “Review” takes you to the Tasks tab, where you can reschedule each one with a single click.',
            more: 'With a few overdue tasks there’s also “Plan for today” — it spaces them out every half hour from now. With more of them, it’s better to go through them one by one: some are probably no longer relevant.',
        },
        noTime: {
            title: 'No time',
            text: 'What’s on for this day but without a specific time: tasks (“sometime today”), all-day events and Wallet payments. It sits above the schedule so it doesn’t get lost among timed entries.',
            more: 'Drag a task onto the schedule to give it a time — or from the schedule back here to remove it. Tick off a payment with the circle — it will be saved in Wallet as paid. To add a task without a time, use the box at the top: just don’t type a time.',
        },
        summary: {
            title: 'Day summary',
            text: 'The day’s sleep, calories, activity and tasks. Calories and macros are measured against your goals in Settings → Goals and preferences; sleep and activity against your best day of the past week.',
        },
        report: {
            title: 'Day entry',
            text: 'A few sentences about how the day went. From your entries and the day’s numbers you can build an export for AI (the ⋯ menu in the header).',
        },
        shopping: {
            title: 'Ingredients to buy',
            text: 'The ingredients of the day’s planned meals (in Week — of the whole week), added up. Untick what you have at home, and the rest goes to Groceries.',
        },
        show: {
            title: 'Show',
            text: 'Which kinds of entries are visible on the schedule. The numbers say how many there are in this view. Save the default set in Settings.',
        },
        week: {
            title: 'Week',
            text: 'Seven days side by side, entries at their times. Drag an entry to another day or another time; click a day to open it.',
            more: 'On your phone the week is a list of days — tap a day to see its schedule.',
        },
        rhythm: {
            title: 'Weekly rhythm',
            text: 'When you usually get up, eat your first meal and fall asleep — with a deviation (±) that shows how regular this rhythm is.',
        },
        toSchedule: {
            title: 'To schedule',
            text: 'Loose tasks without a day. Drag them onto a day or choose “For today” / “Tomorrow”. To add a task without a day, tick “I don’t know when yet”.',
        },
        month: {
            title: 'Month',
            text: 'The whole month in a grid: the day’s main entries, pending tasks and payments. Click a day to open it on the schedule.',
        },
        recurring: {
            title: 'Recurring tasks',
            text: 'Tasks that come back: every day, on weekdays, on chosen days of the week or every month. They always wait on the nearest day — once ticked off, it stays done on that day and the task moves to the next one, at the same time.',
            more: 'Upcoming days show in the planner greyed out. Change the rule in the task window (“Repeat”), and “No” turns it into a regular task.',
        },
        done: {
            title: 'Done',
            text: 'Tasks ticked off in the last few days — you can untick them if it was a mistake.',
        },
        settingsHours: {
            title: 'Schedule hours',
            text: 'The hours between which the day and week schedule is drawn. An entry outside these hours will still fit — the schedule stretches.',
        },
        reminders: {
            title: 'Reminders',
            text: 'A notification for a task with a time — on time or a little before. Here you choose which reminder every new timed task gets; you can change it for a single task in its window.',
            more: 'Notifications need to be turned on on each device (button below). On iPhone they work in the app added to the home screen.',
        },
        defaultVisible: {
            title: 'Visible kinds',
            text: 'Kinds of entries visible when you open the planner. You can change this for a while in the “Show” view.',
        },
        calendar: {
            title: 'Google Calendar',
            text: 'Events from Google Calendar go on the schedule, and events added here go to Google (with export turned on).',
        },
    },
    tour: {
        end: {
            title: 'That’s all',
            text: 'The guide is always available under the “Help” button — that’s also where Getting started is. And “What’s this?” next to each section explains it without the guide.',
        },
    },
    timelineKinds: {
        report: 'Report',
    },
    weekSummary: {
        sleep: 'Sleep · average',
        sleepDays: '{n} of 7 days with a sleep entry',
        noSleep: 'no sleep entries this week',
        calories: 'Calories · average',
        move: 'Activity · total',
        moveBest: 'most in a single day: {duration}',
    },
    rhythm: {
        wakeUp: 'Wake-up',
        firstMeal: 'First meal',
        bedtime: 'Falling asleep',
    },
    weekNote: {
        overdue: {
            title: 'Overdue tasks',
            text: '{n} task has been waiting longer than it should. This week you ticked off {done} of {total}. | {n} tasks have been waiting longer than they should. This week you ticked off {done} of {total}.',
        },
        sleepGaps: {
            title: 'Gaps in your sleep log',
            text: '{n} days without a sleep entry — the average of the rest may be misleading.',
        },
        moveFewDays: {
            title: 'Activity on just a few days',
            text: 'Workouts on only {n} day of the week. | Workouts on only {n} days of the week.',
        },
        numbers: {
            title: 'The week in numbers',
            text: '{withEntries} of 7 days have entries, activity on {n} day. | {withEntries} of 7 days have entries, activity on {n} days.',
        },
    },
    export: {
        macros: 'P{protein}/C{carbs}/F{fat} (sat {saturated}/unsat {unsaturated})/S{sugar}/Fi{fibre}/Salt{salt}',
        meal: 'Meal: {name} ({kcal} kcal, {macros})',
        composition: '; ingredients: {list}',
        workoutPlanned: 'Planned workout: {name}{extra}',
        workout: 'Workout: {name} ({parts})',
        qualityLabel: ', quality {quality} ({label})',
        quality: ', quality {quality}',
        wakeNote: '. Note: {text}',
        wake: 'Wake-up (slept {duration}{suffix}){note}',
        bedtime: 'Sleep — bedtime',
        napNote: ', note: {text}',
        nap: 'Nap ({duration}{suffix}{note})',
        report: 'Report: {text}',
        nutrition: 'Nutrition summary: eaten {kcal}/{kcalGoal} kcal, protein {protein}/{proteinGoal} g, carbs {carbs}/{carbsGoal} g, fat {fat}/{fatGoal} g (saturated {saturated} g, unsaturated {unsaturated} g), sugars {sugar}/{sugarGoal} g, fibre {fibre} g, salt {salt} g',
        taskDone: 'done',
        taskNotDone: 'not done',
        taskList: ', project: {name}',
        task: 'Task: {text} ({state}{list})',
        tasksSummary: 'Tasks summary: {done}/{total} done',
        workoutsTotal: '{duration} in total',
        workoutsDistance: 'distance {distance}',
        workoutsSummary: 'Workouts summary ({n}): {parts}',
        sleepPart: 'sleep {duration}{suffix}',
        napsPart: 'naps: {n} ({duration})',
        sleepSummary: 'Sleep summary: {parts}',
        header: 'Day log ({range}). Analyse the entries and point out patterns, connections and suggestions:',
        columns: { date: 'Date', time: 'Time', event: 'Event' },
        csvHead: 'date,time,event',
    },
    noTime: 'No time',
    day: {
        newEntry: 'New entry',
        showKinds: 'Show entry kinds',
        show: 'Show',
        hiddenKinds: 'hidden kinds: {n}',
        export: 'Export the day for AI',
        todo: 'task to do | tasks to do',
        events: 'event | events',
        freeToday: 'unplanned until the end of the day',
        free: 'unplanned',
        schedule: 'SCHEDULE',
        tasksProgress: 'tasks {done} / {total}',
        scrollToNow: 'Scroll to now',
        now: 'Now',
        tomorrowOn: 'Tomorrow, {date}',
        nothingPlanned: 'nothing planned',
        emptyAdd: 'Nothing planned — add',
        emptyAddColon: 'Nothing planned — add:',
    },
    week: {
        number: 'week {n}',
        export: 'Export the week for AI',
        heading: 'WEEK',
        more: '+ {n} more',
        dragHint: 'Drag a task onto a day and time in the week.',
        summary: 'WEEK SUMMARY',
        rhythm: 'RHYTHM',
        shopping: 'SHOPPING',
        ingredients: 'Ingredients of {n} meal this week | Ingredients of {n} meals this week',
    },
    task: {
        tick: 'Tick off task',
        untick: 'Untick task',
    },
    tasks: {
        toSchedule: 'TO SCHEDULE · {n}',
        addWithoutDay: 'Add without a day',
        allHaveDay: 'All tasks have a day.',
    },
    tasksPage: {
        title: 'Tasks',
        subtitle: '{overdue} overdue · {unscheduled} to schedule',
        today: 'Today',
        tomorrow: 'Tomorrow',
        oldestWaiting: 'the oldest has been waiting {n} day | the oldest has been waiting {n} days',
        quickPlaceholder: 'A task for today — e.g. “17:00 pick up parcel”',
        overdue: 'OVERDUE · {n}',
        noOverdue: 'Nothing overdue. 👏',
        everyHasDay: 'Every task has a day.',
        dragHint: 'Drag onto a day next to it or choose “For today” / “Tomorrow”.',
        recurring: 'RECURRING · {n}',
        addRecurring: 'Add a recurring task',
        noRecurring: 'None — e.g. “Meds” every day at 8:00 or “Bins” on Thursdays.',
        until: 'until {date}',
        next: 'next: {label}',
        next7: 'NEXT 7 DAYS',
        taskCount: '{n} task | {n} tasks',
        done: 'DONE · 7 DAYS',
        noneDone: 'Nothing yet this week.',
    },
    month: {
        heading: 'MONTH',
        weekdays: { mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat', sun: 'Sun' },
        openTasks: 'Pending tasks: {n}',
        noTimeTask: 'No time: {text}',
        dragHint: 'Drag an entry to another day to move it — the time stays the same.',
    },
    settings: {
        title: 'Planner settings',
        hours: 'SCHEDULE HOURS',
        from: 'from',
        to: 'to',
        reminders: 'REMINDERS',
        reminderDefault: 'A new task with a time gets a reminder:',
        pushNoServer: 'Push notifications aren’t enabled on the server yet.',
        pushHomeScreen: 'On iPhone, notifications work in the app added to the home screen (Share → Add to Home Screen).',
        pushUnsupported: 'This browser doesn’t support push notifications.',
        pushDisable: 'Turn off on this device',
        pushEnable: 'Turn on on this device',
        pushHere: 'On here',
        pushNotHere: 'Off here',
        pushOn: 'Notifications turned on on this device.',
        pushOff: 'Notifications turned off on this device.',
        pushDenied: 'Your browser is blocking notifications — allow them in the site settings.',
        pushFailed: 'Couldn’t turn on notifications.',
        moduleReminders: 'Reminders from modules (from 9:00):',
        moduleReminderHint: 'People: birthdays and important dates, out of touch. Pets and Devices: care tasks, warranties, pet birthdays. Habits: at the time set on the habit, if it isn’t ticked off yet. Medications: at the dose time and half an hour later if not ticked off; when the stock lasts less than a week.',
        moduleReminderModules: {
            people: 'People',
            pets: 'Pets',
            devices: 'Devices',
            habits: 'Habits',
            medications: 'Medications',
        },
        visible: 'VISIBLE WHEN OPENED',
        calendar: 'GOOGLE CALENDAR',
        calendarLink: 'Connection and sync',
        firstSteps: 'GETTING STARTED',
        firstStepsText: 'Tasks that help you get to know the planner — each with an explanation of what it is and why.',
        firstStepsShow: 'Show Getting started',
        firstStepsProgress: '{done} of {total}',
        shortcutsTitle: 'KEYBOARD SHORTCUTS',
        shortcuts: {
            prevNext: 'previous / next day (week, month)',
            today: 'today',
            newEntry: 'new entry',
            quickAdd: 'quick add box',
            save: 'save in the entry window',
        },
    },
    allDay: {
        heading: 'ALL DAY',
        paid: 'Paid',
        markPaid: 'Mark as paid: {title}',
        instalmentInWallet: 'Tick off the instalment in Wallet',
    },
    dateNav: {
        prevDay: 'Previous day',
        nextDay: 'Next day',
        prevWeek: 'Previous week',
        nextWeek: 'Next week',
        prevMonth: 'Previous month',
        nextMonth: 'Next month',
        today: 'Today',
        todayKey: 'Today (T)',
        pickWith: '{label} — pick a day',
        pickFromCalendar: 'Pick a day from the calendar',
        thisWeek: 'This week',
        thisMonth: 'This month',
    },
    daySide: {
        missing: {
            sleep: { text: 'No sleep', action: 'Log' },
            calories: { text: 'No meals', action: 'Add' },
            move: { text: 'No activity', action: 'Add a workout' },
        },
        summary: 'SUMMARY',
        ofGoal: '{percent}% of {goal} g',
        noGoal: 'no goal',
        sleep7: 'SLEEP · 7 DAYS',
        noSleepWeek: 'No sleep this week',
        logNight: 'Log a night',
        noEntry: '{day} — no entry',
        avgPerNight: '{duration} per night on average',
        report: 'DAY ENTRY',
        reportPrompt: 'How did the day go? Write a few sentences',
        ingredients: 'Ingredients of {n} meal to Groceries | Ingredients of {n} meals to Groceries',
    },
    entry: {
        markPlanned: 'Mark as planned',
        markDone: 'Mark as done',
        markEaten: 'Mark as eaten',
        plan: 'plan',
        overdue: 'overdue',
        actions: 'Actions: {title}',
    },
    menu: {
        untick: 'Untick',
        taskDone: 'Done',
        backToPlanned: 'Back to planned',
        workoutDone: 'Done',
        eaten: 'Eaten',
        editSeries: 'Edit the whole series',
        openProject: 'Open project',
        openPerson: 'Open person',
        openPet: 'Open pet',
        openDevice: 'Open device',
        edit: 'Edit',
        tomorrow: 'Move to tomorrow',
        duplicate: 'Duplicate',
        remove: 'Delete',
        removeTitle: 'Delete “{title}”?',
        thisEntry: 'this entry',
        removeMessage: 'The entry will disappear from the planner and from its module. This can’t be undone.',
    },
    filtersPanel: {
        heading: 'SHOW',
        hidden: '{n} hidden',
        all: 'All',
    },
    overdueBar: {
        show: 'Show the overdue bar',
        oldest: ' · oldest: {text} ({time})',
        hide: 'Hide until tomorrow',
        spreadTitle: 'Spread overdue tasks over today, every half hour from now',
        spread: 'Plan for today',
        review: 'Review',
    },
    quickAdd: {
        placeholder: 'Add a task, e.g. “14:30 dentist”',
        newTask: 'New task',
        sentenceTitle: 'Type a sentence — it also recognises an event, meal, sleep and workout',
        sentenceLabel: 'Type a sentence: recognises an event, meal, sleep and workout',
        sentence: 'Type a sentence',
        add: 'Add',
        preview: 'Task {text} at {time} — on the schedule',
        quoted: '“{text}”',
    },
    shopping: {
        title: 'Ingredients to buy',
        noIngredients: 'These meals have no ingredients from products — there’s nothing to add.',
        failed: 'Couldn’t gather the ingredients.',
        added: 'The ingredients are in Groceries.',
    },
    sidebar: {
        overdue: 'overdue tasks',
        todo: 'tasks to do',
        withEntries: 'day with entries',
    },
    taskRow: {
        today: 'today',
        overdueFor: 'overdue by {time}',
        reschedule: 'Reschedule: {text}',
        actions: {
            now: 'Now',
            today: 'For today',
            tomorrow: 'Tomorrow',
            untime: 'No time',
            unplan: 'To schedule',
        },
    },
    grid: {
        resize: 'Drag to change the length',
        until: 'until {time}',
    },
    agenda: {
        nothingPlanned: 'Nothing planned.',
        noTime: 'no time',
        tick: 'Tick off',
    },
    wholeDay: {
        heading: 'NO TIME',
        dropHere: 'Drop to remove the time',
        dropHereSentence: 'Drop to remove the time.',
    },
    oldDay: {
        sources: {
            mealEntries: 'meals',
            workouts: 'workouts',
            sleep: 'sleep',
            dayReports: 'day entries',
            meals: 'saved meals',
            products: 'products',
            checklists: 'task lists',
            workoutTypes: 'workout types',
            profile: 'profile',
            events: 'events',
            activities: 'activities',
        },
        overdue: '{n} task overdue. | {n} tasks overdue.',
        oldestSince: 'The oldest has been waiting since {time}.',
        rescheduleFailed: 'Couldn’t reschedule.',
        spreadTitle: 'Spread overdue tasks every half hour from now',
        spread: 'Plan',
        partialFail: 'Couldn’t load: {list}. The rest of the day works normally.',
        loading: 'Loading the day…',
        loadFailed: 'Couldn’t load the day’s data.',
        retry: 'Try again',
    },
    oldWeek: {
        viewingCurrent: 'You’re viewing the current week',
        backToCurrent: 'Back to the current week',
        partialFail: 'Couldn’t load: {list}. The rest of the week works normally.',
        loading: 'Loading the week…',
        loadFailed: 'Couldn’t load the week’s data.',
    },
    header: {
        today: 'Today',
        viewingToday: 'You’re viewing today',
        backToToday: 'Back to today',
        calendar: 'Calendar',
        export: 'Export the log for AI',
    },
    oldSidebar: {
        today: 'Today',
        week: 'Week',
        month: 'Month',
        summaries: 'Summaries',
        tagline: 'DAY PLANNER',
        soon: '{label} — coming soon',
        hide: 'Hide: {label}',
        show: 'Show: {label}',
    },
    oldSummary: {
        heading: 'DAY SUMMARY',
        overdue: 'OVERDUE · {n}',
        openTask: 'Open task',
        editTask: 'Edit task',
        nothingNoTime: 'Nothing is waiting without a time.',
        addTask: 'Add a task',
        macros: 'MACROS',
        meals: '{n} meal | {n} meals',
        sleep7: 'LAST 7 DAYS · SLEEP',
        savedToday: 'Saved on this day',
        editReport: 'Edit report',
        howWasDay: 'How did the day go?',
        reportHint: 'Save a day report — it goes on the timeline at its time and stays in the summary.',
        saveReport: 'Save day report',
    },
    oldTimeline: {
        allHidden: 'All entries for this day are hidden in the “Show” section.',
        emptyTitle: 'This day is still empty',
        emptyText: 'Say what you’re planning, or add an entry by hand — it will appear here at its time.',
        say: 'Say what to add',
        addManually: 'Add by hand',
    },
    exportDialog: {
        title: 'Export for AI',
        subtitle: 'Your log as a table to paste into a chat with a model.',
        close: 'Close',
        from: 'From',
        to: 'To',
        format: 'Format',
        text: 'Text',
        reversed: 'The start day is later than the end day — swap them round.',
        tooLong: 'The export covers at most {n} days — shorten the range.',
        output: 'Exported log',
        empty: 'There are no entries in this range.',
        rows: '{n} row | {n} rows',
        chars: '{n} character | {n} characters',
        copied: 'Copied',
        copy: 'Copy',
    },
    sleepWeek: {
        avg: '{duration} on average',
        none: 'No sleep entries this week',
    },
    template: {
        nameRequired: 'Name is required',
        edit: 'Edit template',
        new: 'New template',
        name: 'Template name',
        namePlaceholder: 'e.g. Trip',
        items: 'ITEMS',
        drag: 'Drag to change the order',
        item: 'Item {n}',
        removeItem: 'Remove item {n}',
        addItem: 'Add item',
        hint: 'Enter adds another item, the handle on the left changes the order. Empty rows are skipped.',
        cancel: 'Cancel',
        saving: 'Saving…',
        save: 'Save',
        removeTitle: 'Delete template?',
        removeMessage: 'Lists created from this template stay. The template itself can’t be recovered.',
    },
    timelineEntry: {
        saturated: 'Saturated',
        salt: 'Salt',
        nowTitle: 'Move the deadline to now',
        now: 'Do it now',
        clearTitle: 'The task stays on today, but without a time',
        clear: 'Remove time',
        quote: '“{text}”',
        syncPending: 'Change waiting to be sent to Google Calendar',
        synced: 'Synced with Google Calendar',
        backToPlanned: 'Back to planned',
        inPlan: 'planned',
        eaten: 'eaten',
        markDone: 'Mark as done',
        done: 'done',
        complete: 'Complete the entry',
        navigate: 'Navigate in Google Maps',
        edit: 'Edit entry',
        ingredients: 'INGREDIENTS',
        noIngredients: 'This entry has no saved ingredients.',
    },
    weekColumn: {
        openDay: 'Open {weekday} {day} in day view',
        navigate: 'Navigate in Google Maps: {place}',
    },
    weekGrid: {
        sleep: 'SLEEP',
        kcal: 'KCAL',
        move: 'ACTIVITY',
        planKcal: 'plan ~{n}',
        planMoves: 'plan {n}',
    },
    weekSummaryPanel: {
        spread: '± is the spread of times this week.',
        toSchedule: 'TO SCHEDULE',
        assign: 'Assign to a day',
        openToAssign: 'Open a task to choose its day.',
        allAssigned: 'All tasks have their day.',
    },
    weekUnscheduled: {
        ticked: 'ticked off',
        more: '{n} task without a time — scroll the bar | {n} tasks without a time — scroll the bar',
    },
};
